import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'

function CustomAutocomplete(props) {
    const [selectedOption, setSelectedOption] = useState([])
    const [singleOption, setSingleOption] = useState({})

    useEffect(() => {
        setSelectedOption([])
    }, [props.onClear])

    const getMultipleValues = (values) => {
        setSelectedOption(values)
        return values.map((item) => item.value)
    }
    const getSingleValue = (values) => {
        console.log(values, 'how this coming here')
        setSingleOption(values)
        return values.value
    }

    const getReturnMultipleValues = (value) => {
        let returnValue = props.options.filter(
            (item) => item.value === parseInt(value)
        )
        console.log('getReturnMultipleValues', value, returnValue)
        if (returnValue.length) {
            let allValues = selectedOption.concat(returnValue)
            setSelectedOption(allValues)
            props.onChange(getMultipleValues(allValues))
        }
    }

    const getReturnSingleValues = (value) => {
        console.log(value, props.options, 'completed value')
        let returnValue = props.isString
            ? props.options.filter((item) => item.value == value)
            : props.options.filter((item) => item.value == parseInt(value))

        if (returnValue.length) {
            console.log('coming here also')
            let allValues = returnValue[0]
            setSingleOption(allValues)
            props.onChange(getSingleValue(allValues))
        }
    }

    useEffect(() => {
        if (props.options && props.options.length) {
            if (props.value && props.value !== '') {
                let options = [...props.options]
                let filtered = options.filter(
                    (item) => item.value == props.value
                )
                if (props.multiple && props.value.length) {
                    filtered = options.filter((item) =>
                        props.value.includes(item.value)
                    )
                    setSelectedOption(filtered)
                } else {
                    setSingleOption(filtered[0])
                    setSelectedOption([])
                }
            } else {
                setSingleOption({ show: '', value: '' })
            }
        } else {
            setSingleOption({ show: '', value: '' })
        }
    }, [props.value, props.options])

    const customFilter = (options, { inputValue }) => {
        const inputLowerCase = inputValue.toLowerCase()

        return options.filter((option) => {
            console.log('i am autocomplete ', option)
            if (props?.searchType === 'startsWith') {
                return option?.show?.toLowerCase()?.startsWith(inputLowerCase)
            } else {
                return option?.show?.toLowerCase()?.includes(inputLowerCase)
            }
        })
    }

    return (
        <>
            {props.multiple ? (
                <Autocomplete
                    id={props.id}
                    multiple={props.multiple}
                    options={props.options}
                    value={selectedOption}
                    onChange={(event, value) => {
                        if (value) {
                            props.onChange(getMultipleValues(value))
                        } else {
                            props.onChange([])
                        }
                    }}
                    freeSolo={props.freeSolo}
                    getOptionLabel={(option) => option.show}
                    renderOption={(props, option) => (
                        <li {...props} key={option.value}>
                            {' '}
                            {option.show}{' '}
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={props.label}
                            variant={props.variant ? props.variant : 'outlined'}
                            error={props.error}
                            value={props.value}
                            size={props.size}
                            name={props.name}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && e.target.value) {
                                    getReturnMultipleValues(e.target.value)
                                }
                            }}
                            helperText={props.helperText}
                            autoFocus={props.autoFocus}
                        />
                    )}
                    autoFocus={props.autoFocus}
                />
            ) : (
                <Autocomplete
                    id={props.id}
                    filterOptions={customFilter}
                    options={props.options}
                    value={singleOption}
                    freeSolo={props.freeSolo}
                    onChange={(event, value) => {
                        if (value) {
                            props.onChange(getSingleValue(value))
                        } else {
                            props.onChange('')
                        }
                    }}
                    renderOption={(props, option) => (
                        <li {...props} key={option.value}>
                            {' '}
                            {option.show}{' '}
                        </li>
                    )}
                    getOptionLabel={(option) => option.show}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={props.label}
                            variant={props.variant ? props.variant : 'outlined'}
                            error={props.error}
                            value={props.value}
                            size={props.size}
                            name={props.name}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && e.target.value) {
                                    getReturnSingleValues(e.target.value)
                                }
                            }}
                            onPaste={(e) => {
                                if (props.triggerPasteEvent) {
                                    console.log('props is true')
                                    getReturnSingleValues(e.target.value)
                                }
                            }}
                            helperText={props.helperText}
                            autoFocus={props.autoFocus}
                        />
                    )}
                    autoFocus={props.autoFocus}
                />
            )}
        </>
    )
}
export default CustomAutocomplete
